import React, { Component } from 'react';

import get from 'lodash/get';

import Button from '@atlaskit/button';

import { messages } from '@qality/common-messages';
import { TestCase, TestStepsCollection } from '@qality/common-model';
import {
  StorageOfUniqueDialogs,
  TestStepService,
} from '@qality/common-service';

import './_test-execution-history-list.scss';

type Props = {
  testCase: TestCase;
};

type State = {
  testSteps: TestStepsCollection;
};

export default class TestExecutionEmptyHistoryList extends Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      testSteps: null,
    };
  }

  testCaseExecutionDialog = (): void => {
    const testCaseName = get(this.props.testCase, 'fields.summary');
    StorageOfUniqueDialogs.get(
      'TestCaseExecutionDialog'
    ).openTestCaseExecutionDialog(this.props.testCase.id, testCaseName);
  };

  async componentDidMount(): Promise<void> {
    const testSteps = await TestStepService.fetchTestSteps(
      this.props.testCase.id
    );
    this.setState({ testSteps });
  }

  render(): React.ReactNode {
    return (
      <div className='execution-history-info-wrapper'>
        <div className='execution-history-info-header'>
          {messages['info.testExecutionHistoryPage.history.is.empty.message']}
        </div>
        <Button onClick={this.testCaseExecutionDialog} appearance='primary'>
          <span>Execute Test Case</span>
        </Button>
      </div>
    );
  }
}
